/**
 * Generate unique ID for retry attempts
 */
export const generateRetryId = () => `retry-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`

